import { ASL_STATION_INFO, ASL_EQUIPMENT_INFO, ASL_OTHERS_INFO, ASL_SUPPORTING_DOCUMENTS } from 'common/application.const/Licence/MyLicence/amateurStationLicence';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';
import { LICENCE_DETAILS as CANCEL_LICENCE_DETAILS, SUPPORTING_DOCUMENTS } from 'common/application.const/Licence/MyApplication/cancelLicence';
import { LICENCE_DETAILS as RENEW_LICENCE_DETAILS } from 'common/application.const/Licence/MyApplication/renewLicence';
import { LICENCE_DETAILS as AMEND_LICENCE_DETAILS, BILLING_DETAILS, SUPPORTING_DOCUMENTS as AMEND_SUPPORTING_DOCUMENTS } from 'common/application.const/Licence/MyApplication/amendLicence';
import { formatDateTo_ddMMyyyy } from 'utils/application.helpers';

export const formatASL = async (licenceDetails: any, caseTypeID: string, application?: string, transactionType?: any) => {

    let stationDetails, equipmentDetails, otherDetails, licence;
    let newDocs;
    let newPayload;
    let docsLic;
    if (licenceDetails && licenceDetails.stationInfo && licenceDetails.stationInfo.length > 0) {
        const stationInfo = licenceDetails.stationInfo;
        stationDetails = stationInfo[0];
    }

    if (licenceDetails && licenceDetails.equipmentInfo && licenceDetails.equipmentInfo.length > 0) {
        equipmentDetails = licenceDetails?.equipmentInfo?.map((value: Record<string, string>, index: number) => ({
            no: `${index + 1}`,
            manufacturer: value?.manufacturer ?? '-',
            model: value?.model ?? '-',
            outputPower: value?.outputPowerWTransmitter ?? '-',
            frequencyRangeFrom: value?.frequencyRangeMHzTransmitterFrom ?? '--',
            frequencyRangeTo: value?.frequencyRangeMHzTransmitterTo ?? ''
        }));
    }

    if (licenceDetails && licenceDetails.otherDetails) {
        otherDetails = licenceDetails.otherDetails;
    }

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category,
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    licence = {
        id: 'amateur-station',
        formID: 'amateur-station',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {
            [`${ASL_STATION_INFO}-station-name`]: stationDetails?.stationName ?? '',
            [`${ASL_STATION_INFO}-assigned-call-sign`]: stationDetails?.stationName ?? '',
            [`${ASL_STATION_INFO}-occupation`]: stationDetails?.occupationDesignation ?? '',
            [`${ASL_STATION_INFO}-operator-qualification`]: stationDetails?.amateurOperatorQualification ?? '',
            [`${ASL_STATION_INFO}-postal`]: stationDetails?.address?.postalCode ?? '',
            [`${ASL_STATION_INFO}-block-house`]: stationDetails?.address?.blockNo ?? '',
            [`${ASL_STATION_INFO}-street`]: stationDetails?.address?.streetName ?? '',
            [`${ASL_STATION_INFO}-building`]: stationDetails?.address?.buildingName ?? '',
            [`${ASL_STATION_INFO}-floor`]: stationDetails?.address?.floor ?? '',
            [`${ASL_STATION_INFO}-unit`]: stationDetails?.address?.unit ?? '',
            [`${ASL_STATION_INFO}-location`]: stationDetails?.locationOfStation ?? '',
            [`${ASL_STATION_INFO}-certificate-no`]: stationDetails?.certificateNo ?? '',
            [`${ASL_EQUIPMENT_INFO}-equipmentInfoTable`]: equipmentDetails ? [...(equipmentDetails)] : '-',
            [`${ASL_EQUIPMENT_INFO}-asl-manufacturer`]: equipmentDetails?.manufacturer ?? '',
            [`${ASL_EQUIPMENT_INFO}-model`]: equipmentDetails?.model ?? '',
            [`${ASL_EQUIPMENT_INFO}-output-power`]: equipmentDetails?.outputPowerWTransmitter ?? '',
            [`${ASL_EQUIPMENT_INFO}-frequency-range-from`]: equipmentDetails?.frequencyRangeMHzTransmitterFrom ?? '',
            [`${ASL_EQUIPMENT_INFO}-frequency-range-to`]: equipmentDetails?.frequencyRangeMHzTransmitterTo ?? '',
            [`${ASL_OTHERS_INFO}-public-contact`]: otherDetails?.publicContactNo ?? '',
            [`${ASL_OTHERS_INFO}-proposed-use`]: otherDetails?.proposedUseOfSystem ?? '',
            [`${ASL_OTHERS_INFO}-remarks`]: otherDetails?.remarks ?? '',
            [`${ASL_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined,
        }
    };

    if (transactionType === 'Cancel') {
        licence = {
            id: 'cancel-licence-details',
            formID: 'cancel-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${CANCEL_LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
                [`${CANCEL_LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
                [`${CANCEL_LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

                [`${CANCEL_LICENCE_DETAILS}-cancellationReason`]: licenceDetails?.cancellationInformation?.cancellationReason ?? '',
                [`${CANCEL_LICENCE_DETAILS}-effectiveDateOfCancellation`]:
                    formatDateTo_ddMMyyyy(licenceDetails?.cancellationInformation?.effectiveDateOfCancellation) ?? '',

                [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : '-'
            }
        };
    }

    if (transactionType === 'Renew') {
        licence = {
            id: 'renew-licence-details',
            formID: 'renew-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${RENEW_LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
                [`${RENEW_LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.uen ?? '',
                [`${RENEW_LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNumber ?? '',

                [`${RENEW_LICENCE_DETAILS}-invoiceNo`]: licenceDetails?.licenceRenewal?.invoiceNumber ?? '',
                [`${RENEW_LICENCE_DETAILS}-renewalAmount`]: licenceDetails?.licenceRenewal?.renewalAmount ?? '',
                [`${RENEW_LICENCE_DETAILS}-giroIndicator`]: licenceDetails?.licenceRenewal?.giroIndicator ?? '',
                [`${RENEW_LICENCE_DETAILS}-dateOfExpiry`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.dateOfExpiry) ?? '',
                [`${RENEW_LICENCE_DETAILS}-paymentDueDate`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.paymentDueDate) ?? '',
                [`${RENEW_LICENCE_DETAILS}-renewalPeriod`]: licenceDetails?.licenceRenewal?.renewalPeriod ?? ''
            }
        };
    }

    if (transactionType === 'Amend') {

        const mapped = licenceDetails?.licenceDetails?.iWantToAmend?.map((data: { [key: string]: string }) => {
            return {
                type: data.mixedValue
            };
        });

        licence = {
            id: 'amend-licence-details',
            formID: 'amend-licence-details',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${AMEND_LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
                [`${AMEND_LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.registrationNoUenOther ?? '',
                [`${AMEND_LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNo ?? '',
                [`${AMEND_LICENCE_DETAILS}-amend-table`]: Array.isArray(mapped) && mapped.length > 0 ? [...mapped] : [],


                [`${AMEND_LICENCE_DETAILS}-name`]: licenceDetails?.correspondencePersonParticulars?.name ?? '',
                [`${AMEND_LICENCE_DETAILS}-designation`]: licenceDetails?.correspondencePersonParticulars?.designation ?? '',
                [`${AMEND_LICENCE_DETAILS}-officeTelNumber`]: licenceDetails?.correspondencePersonParticulars?.officeTelNumber ?? '',
                [`${AMEND_LICENCE_DETAILS}-mobileNumber`]: licenceDetails?.correspondencePersonParticulars?.mobileNumber ?? '',
                [`${AMEND_LICENCE_DETAILS}-email`]: licenceDetails?.correspondencePersonParticulars?.email ?? '',

                [`${AMEND_LICENCE_DETAILS}-addressType`]: licenceDetails?.correspondenceAddress?.addressType ?? '',
                [`${AMEND_LICENCE_DETAILS}-postalCode`]: licenceDetails?.correspondenceAddress?.address.postalCode ?? '',
                [`${AMEND_LICENCE_DETAILS}-blockNo`]: licenceDetails?.correspondenceAddress?.address.blockNo ?? '',
                [`${AMEND_LICENCE_DETAILS}-streetName`]: licenceDetails?.correspondenceAddress?.address.streetName ?? '',
                [`${AMEND_LICENCE_DETAILS}-buildingName`]: licenceDetails?.correspondenceAddress?.address.buildingName ?? '',
                [`${AMEND_LICENCE_DETAILS}-floor`]: licenceDetails?.correspondenceAddress?.address.floor ?? '',
                [`${AMEND_LICENCE_DETAILS}-unit`]: licenceDetails?.correspondenceAddress?.address.unit ?? '',

                [`${AMEND_LICENCE_DETAILS}-foreignAddress1`]: licenceDetails?.correspondenceAddress?.foreignAddress1 ?? '',
                [`${AMEND_LICENCE_DETAILS}-foreignAddress2`]: licenceDetails?.correspondenceAddress?.foreignAddress2 ?? '',
                [`${AMEND_LICENCE_DETAILS}-foreignAddress3`]: licenceDetails?.correspondenceAddress?.foreignAddress3 ?? '',
                [`${AMEND_LICENCE_DETAILS}-zipCode`]: licenceDetails?.correspondenceAddress?.zipCode ?? '',

                [`${BILLING_DETAILS}-sameAsCorrespondencePersonParticulars`]:
                    licenceDetails?.billingPersonParticulars?.sameAsCorrespondencePersonParticulars ?? '',
                [`${BILLING_DETAILS}-name`]: licenceDetails?.billingPersonParticulars?.name ?? '',
                [`${BILLING_DETAILS}-designation`]: licenceDetails?.billingPersonParticulars?.designation ?? '',
                [`${BILLING_DETAILS}-officeTelNumber`]: licenceDetails?.billingPersonParticulars?.officeTelNumber ?? '',
                [`${BILLING_DETAILS}-mobileNumber`]: licenceDetails?.billingPersonParticulars?.mobileNumber ?? '',
                [`${BILLING_DETAILS}-email`]: licenceDetails?.billingPersonParticulars?.email ?? '',
                [`${BILLING_DETAILS}-notifyViaEmailForFutureLicenceRenewal`]:
                    licenceDetails?.billingPersonParticulars?.notifyViaEmailForFutureLicenceRenewal ?? '',

                [`${BILLING_DETAILS}-postalCode`]: licenceDetails?.billingAddress?.address.postalCode ?? '',
                [`${BILLING_DETAILS}-blockNo`]: licenceDetails?.billingAddress?.address.blockNo ?? '',
                [`${BILLING_DETAILS}-streetName`]: licenceDetails?.billingAddress?.address.streetName ?? '',
                [`${BILLING_DETAILS}-buildingName`]: licenceDetails?.billingAddress?.address.buildingName ?? '',
                [`${BILLING_DETAILS}-floor`]: licenceDetails?.billingAddress?.address.floor ?? '',
                [`${BILLING_DETAILS}-unit`]: licenceDetails?.billingAddress?.address.unit ?? '',

                [`${AMEND_SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
            }
        };
    }

    return licence;
}

const aslPayload = {
    formatASL
};

export default aslPayload;